// @ts-strict-ignore
import type { InstanceSearchServiceConfig } from '../models'

import type { InstanceSearchManagementService } from './interfaces/instance-search-management.service'

import { ApiService } from './api.service'

export class SearchConfigurationService
  extends ApiService
  implements InstanceSearchManagementService
{
  private static readonly ENDPOINTS = {
    global: 'globalconfig',
  }

  public constructor(protected readonly BASE_URL: string) {
    super(BASE_URL)
  }

  async readConfig(instance: string): Promise<InstanceSearchServiceConfig> {
    const url = `${instance}/${SearchConfigurationService.ENDPOINTS.global}`
    const response = await this.fetch<InstanceSearchServiceConfig>(url, undefined, undefined, true)
    return response.data
  }

  async updateConfig(
    instance: string,
    config: InstanceSearchServiceConfig,
  ): Promise<InstanceSearchServiceConfig> {
    const contentType = this.CONTENT_TYPES.JSON
    const requestInit: RequestInit = {
      method: 'PUT',
      headers: {
        [this.REQUEST_HEADERS.CONTENT_TYPE]: contentType,
      },
      body: this.encodeRequestBody(config, contentType),
    }
    const response = await this.fetch<any>(
      `${instance}/${SearchConfigurationService.ENDPOINTS.global}`,
      undefined,
      requestInit,
      true,
    )
    return response.data.current
  }

  async instanceAlreadyExists(instance: string): Promise<boolean> {
    const url = `${instance}`
    try {
      await this.fetch<any>(url, undefined, undefined, true)
      return true
    } catch (error) {
      if (error.status === 404) {
        return false
      }
    }
  }

  async createClient(instance: string, clientData: any): Promise<any> {
    const requestInit: RequestInit = {
      method: 'PUT',
      headers: {
        [this.REQUEST_HEADERS.CONTENT_TYPE]: this.CONTENT_TYPES.JSON,
      },
      body: this.encodeRequestBody(clientData, this.CONTENT_TYPES.JSON),
    }
    const response = await this.fetch<any>(instance, undefined, requestInit, true)
    return response.data
  }
}
